
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11603',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11603",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.446",
  "dashboard-client-types": "static-1.240",
  "data-fetching-client": "static-1.9493",
  "foundations-components": "static-1.7554",
  "foundations-components-legacy": "static-1.579",
  "foundations-theming": "static-1.4227",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7821",
  "hub-http-shared-msw-handlers": "static-1.9509",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11248",
  "I18n": "static-7.1574",
  "jasmine-runner": "static-1.6288",
  "marketplace-storefront-base": "static-1.11663",
  "quartz": "static-1.6756",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16466",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2678",
  "reporting-testing-lib": "static-1.8523",
  "settings-ui-lib": "static-1.12338",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6759",
  "ui-addon-i18n": "static-1.10957",
  "ui-addon-react-router-dom": "static-1.9362",
  "unified-auth": "static-1.234",
  "unified-auth-core-lib": "static-1.515",
  "usage-tracker": "static-1.7150",
  "usage-tracker-core": "static-1.7000",
  "customer-data-property-utils": "static-1.7894",
  "history": "static-4.47",
  "hub-http": "static-1.6036",
  "integrations-lib": "static-1.15461",
  "marketplace-ui-common": "static-1.18990",
  "property-management-iframe": "static-1.12404",
  "quartz-config": "static-1.534",
  "quartz-core": "static-1.5975",
  "quartz-routing": "static-1.186",
  "quick-fetch": "static-1.3750",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4450",
  "ts-schema": "static-1.3919",
  "ui-universal-auth": "static-1.8720",
  "UIComponents": "static-3.8195",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3244",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3033",
  "quartz-webpack": "static-1.2980",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3823",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4652",
  "foundations-theming-specialty": "static-1.1943",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9243",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5188",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1254",
  "ui-fonts": "static-1.510",
  "ui-images": "static-2.1096",
  "bend-plugin-foundations-theming": "static-1.2710",
  "foundations-theming-base": "static-1.3212",
  "stylex": "static-1.27",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2932",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4142",
  "ai-components-ui-library": "static-1.8387",
  "ai-rendering-library": "static-1.9349",
  "chirp-fetch": "static-1.1698",
  "connections-embed-lib": "static-1.657",
  "copilot-toolkit": "static-1.10572",
  "laboratory-lib": "static-3.6976",
  "marketplace-embed": "static-1.21514",
  "marketplace-ui-details": "static-1.8886",
  "marketplace-ui-reviews": "static-1.18946",
  "marketplace-ui-tracking": "static-1.13161",
  "sanitize-text": "static-1.7958",
  "ui-addon-video-player": "static-1.8512",
  "usage-tracker-multi": "static-1.5564",
  "usage-tracker-session-replay": "static-1.4836",
  "wootric-nps": "static-1.6800",
  "apollo-link-hub-http": "static-2.4466",
  "immer": "static-1.33",
  "immerable": "static-1.3971",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66590",
  "cssUtils": "static-1.736",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11556",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10025",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10187",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7140",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17523",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4337",
  "foundations-components-test-utils": "static-1.5037",
  "quartz-i18n": "static-1.431",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3548",
  "customer-data-objects": "static-1.7465",
  "property-translator": "static-1.5228",
  "frontend-preferences-client": "static-1.7740",
  "hs-promise-utils": "static-1.5409",
  "hubspot-apollo-client": "static-1.4697",
  "integrations-error-boundary-lib": "static-1.12876",
  "integrations-tracking-lib": "static-1.5405",
  "native-integrations-shared-strings": "static-1.7604",
  "reselect": "static-2.16",
  "sanitize": "static-1.4290",
  "superstore": "static-1.4586",
  "ui-shepherd-react": "static-3.9963",
  "ai-settings-ui-library": "static-1.7485",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4493",
  "immutable-less": "static-1.4470",
  "marketplace-ui-client-types": "static-1.16397",
  "nav-meta": "static-1.28950",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10053",
  "ui-addon-upgrades": "static-9.17682",
  "inbound-db-properties-service-client": "static-1.3690",
  "property-management-common": "static-1.4691",
  "ui-addon-iframeable": "static-1.8861",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.431",
  "quartz-head": "static-1.421",
  "quartz-test": "static-1.431",
  "quartz-tracking": "static-1.135",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2968",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20387",
  "ContentUtils": "static-1.67666",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2303",
  "customer-data-filters-ui": "static-1.38958",
  "customer-data-objects-ui-components": "static-1.12825",
  "customer-data-reference-ui-components": "static-1.12962",
  "embedded-academy-lib": "static-1.13594",
  "ExportDialog": "static-6.10203",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40694",
  "reporting-snowflake": "static-1.55208",
  "reporting-ui-components": "static-2.63861",
  "reporting-visualizations": "static-1.58666",
  "ui-addon-teams": "static-1.21264",
  "magpie-lib": "static-1.5410",
  "magpie-types": "static-1.4870",
  "simple-logging-lib": "static-1.2866",
  "navigation-components": "static-1.17313",
  "ai-studio-lib": "static-1.11039",
  "developer-experience-shared-components": "static-1.10296",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7806",
  "ui-tool-access": "static-1.9961",
  "usage-based-billing-components-lib": "static-1.8046",
  "usage-tracker-anonymous": "static-1.5567",
  "usage-tracker-public": "static-1.6961",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3433",
  "persist-promise": "static-1.3524",
  "reference-resolvers": "static-1.7976",
  "ui-extensibility-client-types": "static-1.3760",
  "hubspot-apollo-cache": "static-1.156",
  "universal-page-editor-lib": "static-1.2816",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2225",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4885",
  "purchase-motions-components": "static-1.5502",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1367",
  "crm-component-utils": "static-1.38516",
  "crm-properties-common-lib": "static-1.5688",
  "framework-data-schema-resolvers": "static-1.6689",
  "reference-resolvers-lite": "static-1.7910",
  "navigation-messaging": "static-1.6640",
  "hubspotter-http-shared-msw-handlers": "static-1.9507",
  "cms-field-types": "static-1.4622",
  "content-icons-ui": "static-1.2158",
  "conversations-skeleton-state": "static-1.7063",
  "crm-message-bus": "static-1.42405",
  "customer-data-filters-ui-msw-helpers": "static-1.21393",
  "customer-data-ui-utilities": "static-1.9639",
  "FormUrlGenerator": "static-2.4544",
  "framework-builder-read-service-client": "static-1.3848",
  "framework-data-schema-quick-fetch": "static-1.6594",
  "multi-account-reference-resolvers": "static-1.789",
  "onboarding-tours": "static-1.16284",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13094",
  "academy-common-lib": "static-1.13054",
  "content-assistance-lib": "static-1.7471",
  "dashboard-lib": "static-1.80688",
  "file-manager-components": "static-1.22939",
  "getting-started-shared-tasks": "static-1.17926",
  "hubspot-prosemirror": "static-1.17644",
  "hubspot-prosemirror-plugins": "static-1.17636",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19495",
  "share-with-third-party-component-lib": "static-1.8508",
  "ui-addon-draggable": "static-3.4581",
  "ui-asset-management-lib": "static-1.10731",
  "ui-business-units-lib": "static-1.8845",
  "user-context": "static-1.4915",
  "growth-payments-core": "static-1.24769",
  "reporting-plugins": "static-1.10005",
  "reporting-reports": "static-1.66268",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.541",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28883",
  "react-codemirror": "static-1.10443",
  "apps-service-types": "static-1.3693",
  "oauth-service-types": "static-1.4061",
  "onboarding-scopes": "static-1.6279",
  "onboarding-tours-client": "static-1.4498",
  "platform-infra-nav-components": "static-1.7507",
  "subscription-experience-data-types": "static-1.14607",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8609",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2173",
  "purchase-motions-api": "static-1.5505",
  "signup-constants": "static-1.18441",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3730",
  "card-properties-lib": "static-1.43564",
  "crm-actions": "static-1.6120",
  "crm-cards-data": "static-1.1240",
  "crm-cards-sdk": "static-1.42963",
  "customer-data-properties": "static-1.50840",
  "customer-data-properties-shared-msw-handlers": "static-1.8836",
  "customer-data-tracking": "static-1.6698",
  "conditional-properties-service-client": "static-1.3638",
  "crm-pipelines-api-client-types": "static-1.3979",
  "multi-currency-client-types": "static-1.3532",
  "external-options-client-types": "static-1.3999",
  "react-dnd-compat": "static-1.4436",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5175",
  "growth-onboarding-confetti": "static-1.2888",
  "growth-onboarding-next-action-utils": "static-1.1327",
  "onboarding-tours-utils": "static-1.350",
  "ui-shepherd-tracker": "static-1.7344",
  "academy-service-client": "static-1.3496",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27981",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8200",
  "video-components-external": "static-1.10612",
  "video-data-lib": "static-1.34270",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8384",
  "payment-link-components": "static-1.22978",
  "ui-addon-emoji-picker": "static-1.9704",
  "EmailSignatureEditor": "static-1.23940",
  "viral-links-lib": "static-1.6851",
  "data-token-picker": "static-1.16066",
  "FileManagerLib": "static-1.38579",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5060",
  "getting-started-shared-tasks-store": "static-1.17044",
  "campaign-roi-lib": "static-1.8319",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.207",
  "eligibility-engine-service-types": "static-1.3011",
  "crm_data": "static-4.91262",
  "crm-links": "static-1.6083",
  "customer-data-sidebar": "static-2.45457",
  "enrichment-properties-lib": "static-1.15088",
  "crm-fe-perf": "static-1.22722",
  "calling-global-api": "static-1.63726",
  "calling-internal-common": "static-1.31111",
  "calling-lifecycle-internal": "static-1.65108",
  "calling-lifecycle-messages": "static-1.57402",
  "commerce-products-lib": "static-1.8903",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.494",
  "inbounddb-objects-service-types": "static-1.4063",
  "meetings-icalendar-utils-lib": "static-1.449",
  "object-builder-ui-client": "static-1.48031",
  "pipeline-validation-client-types": "static-1.3802",
  "property-value-citations": "static-1.1454",
  "pulse": "static-1.330",
  "smart-property-lib": "static-1.5970",
  "tiered-pricing": "static-1.852",
  "ui-addon-form-validation": "static-1.10810",
  "growth-onboarding-next-action-components": "static-1.1355",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6399",
  "content-media-composition-data-lib": "static-1.11512",
  "content-media-compositions": "static-2.15519",
  "media-bridge-lib": "static-1.18589",
  "commerce-tours-lib": "static-1.5742",
  "growth-onboarding-reliability": "static-1.4902",
  "sales-checkout-service-client": "static-1.3484",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21331",
  "sales-email-signature-service-client": "static-1.3660",
  "audio-components": "static-1.5634",
  "FileManagerCore": "static-1.38438",
  "FileManagerImages": "static-1.36090",
  "video-components": "static-1.12615",
  "crm_universal": "static-1.21684",
  "customer-data-email": "static-1.17694",
  "calling-error-reporting": "static-1.31117",
  "card-payment-highlight-lib": "static-1.36542",
  "card-subscription-highlight-lib": "static-1.38897",
  "commerce-billing-lib": "static-1.18540",
  "commerce-contract-lib": "static-1.11248",
  "customer-data-content": "static-1.26898",
  "invoices-highlight-card-lib": "static-1.54081",
  "orders-highlight-card-lib": "static-1.20905",
  "products-highlight-card-lib": "static-1.17187",
  "project-storage": "static-1.4549",
  "quotes-highlight-card-lib": "static-1.71260",
  "breeze-intelligence-kit": "static-1.5344",
  "crm-source-interpretation-lib": "static-1.5146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9592",
  "policy-lib": "static-1.6603",
  "shared-worker-versioning": "static-1.10854",
  "calling-usage-tracker": "static-1.6356",
  "voice-sms-access-library": "static-1.288",
  "commerce-permissions": "static-1.575",
  "products-iframe-lib": "static-1.7357",
  "products-ui-components-shared-msw-handlers": "static-1.9891",
  "directed-graph": "static-1.753",
  "event-emitter": "static-1.763",
  "react-tinymce": "static-1.54660",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9655",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53786",
  "tinymce-plugins": "static-1.56900",
  "tinymce-themes": "static-1.55756",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4348",
  "video-embed": "static-1.35104",
  "social-insights-client-types": "static-1.21398",
  "sequences-lib": "static-1.7708",
  "ui-gdpr-components": "static-1.10163",
  "commerce-shared-components-lib": "static-1.17960",
  "commerce-subscription-lib": "static-1.36474",
  "commerce-tools-ui-lib": "static-1.9833",
  "utility-belt": "static-1.2356",
  "payments-enrollment-embed-lib": "static-1.22072",
  "products-ui-components": "static-1.39422",
  "quotes-client-types": "static-1.37349",
  "quotes-ui-lib": "static-1.79980",
  "SalesContentIndexUI": "static-3.8927",
  "accounting-integrations-ui-components": "static-1.6746",
  "invoices-ui-lib": "static-1.54097",
  "commerce-products-api": "static-1.1979",
  "SafeStorage": "static-1.4220",
  "invoices-iframe-lib": "static-1.56155",
  "quotes-modal-lib": "static-1.101937",
  "calling-orchestration-schema": "static-1.35065",
  "sales-views-client-types": "static-1.4103",
  "hub-http-contrib": "static-1.2859",
  "interframe": "static-3.4605",
  "tinymce-data": "static-1.39871",
  "ui-addon-sales-email": "static-1.5029",
  "layout-dnd-components": "static-1.12062",
  "layout-dnd-utils": "static-1.11037",
  "ui-brand-identity-lib": "static-1.13964",
  "NamespacedHubStyle": "static-2.8911",
  "outpost": "static-1.4020",
  "sequences-client-types-lib": "static-1.7565",
  "customer-data-associations": "static-1.7154",
  "framework-data-table": "static-2.11448",
  "customer-data-rte": "static-1.32479",
  "cv-backend-services": "static-1.1505",
  "growth-onboarding-empty-states": "static-1.5386",
  "InboxConnectUtils": "static-4.14262",
  "payments-post-enroll-local-storage-lib": "static-1.4928",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7157",
  "commerce-tax-lib": "static-1.333",
  "property-description-translator": "static-1.3674",
  "FireAlarmUi": "static-1.4345",
  "sales-templates-service-types-lib": "static-1.4006",
  "commerce-analytics-service-client": "static-1.3472",
  "totals-ui-components": "static-1.23035",
  "ContentData": "static-1.67741",
  "layout-data-lib": "static-1.9362",
  "deal-intel-decorators": "static-1.1300",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27748",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3653",
  "advanced-menus-core": "static-1.14837",
  "advanced-menus-lib": "static-1.11810",
  "ui-memberships-settings-lib": "static-1.33467",
  "deal-intel-utils": "static-1.1304",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14836",
  "simple-menus-lib": "static-1.16353"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11603",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.446",
  "dashboard-client-types": "/dashboard-client-types/static-1.240",
  "data-fetching-client": "/data-fetching-client/static-1.9493",
  "foundations-components": "/foundations-components/static-1.7554",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.579",
  "foundations-theming": "/foundations-theming/static-1.4227",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7821",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9509",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11248",
  "I18n": "/I18n/static-7.1574",
  "jasmine-runner": "/jasmine-runner/static-1.6288",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11663",
  "quartz": "/quartz/static-1.6756",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16466",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2678",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8523",
  "settings-ui-lib": "/settings-ui-lib/static-1.12338",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6759",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10957",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9362",
  "unified-auth": "/unified-auth/static-1.234",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.515",
  "usage-tracker": "/usage-tracker/static-1.7150",
  "usage-tracker-core": "/usage-tracker-core/static-1.7000",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7894",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6036",
  "integrations-lib": "/integrations-lib/static-1.15461",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18990",
  "property-management-iframe": "/property-management-iframe/static-1.12404",
  "quartz-config": "/quartz-config/static-1.534",
  "quartz-core": "/quartz-core/static-1.5975",
  "quartz-routing": "/quartz-routing/static-1.186",
  "quick-fetch": "/quick-fetch/static-1.3750",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4450",
  "ts-schema": "/ts-schema/static-1.3919",
  "ui-universal-auth": "/ui-universal-auth/static-1.8720",
  "UIComponents": "/UIComponents/static-3.8195",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3244",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3033",
  "quartz-webpack": "/quartz-webpack/static-1.2980",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3823",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4652",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1943",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9243",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5188",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1254",
  "ui-fonts": "/ui-fonts/static-1.510",
  "ui-images": "/ui-images/static-2.1096",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2710",
  "foundations-theming-base": "/foundations-theming-base/static-1.3212",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2932",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4142",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8387",
  "ai-rendering-library": "/ai-rendering-library/static-1.9349",
  "chirp-fetch": "/chirp-fetch/static-1.1698",
  "connections-embed-lib": "/connections-embed-lib/static-1.657",
  "copilot-toolkit": "/copilot-toolkit/static-1.10572",
  "laboratory-lib": "/laboratory-lib/static-3.6976",
  "marketplace-embed": "/marketplace-embed/static-1.21514",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8886",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18946",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13161",
  "sanitize-text": "/sanitize-text/static-1.7958",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8512",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5564",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4836",
  "wootric-nps": "/wootric-nps/static-1.6800",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4466",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3971",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66590",
  "cssUtils": "/cssUtils/static-1.736",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11556",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10025",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10187",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7140",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17523",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4337",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5037",
  "quartz-i18n": "/quartz-i18n/static-1.431",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3548",
  "customer-data-objects": "/customer-data-objects/static-1.7465",
  "property-translator": "/property-translator/static-1.5228",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7740",
  "hs-promise-utils": "/hs-promise-utils/static-1.5409",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4697",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12876",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5405",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7604",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4290",
  "superstore": "/superstore/static-1.4586",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9963",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7485",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4493",
  "immutable-less": "/immutable-less/static-1.4470",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16397",
  "nav-meta": "/nav-meta/static-1.28950",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10053",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17682",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3690",
  "property-management-common": "/property-management-common/static-1.4691",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8861",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.431",
  "quartz-head": "/quartz-head/static-1.421",
  "quartz-test": "/quartz-test/static-1.431",
  "quartz-tracking": "/quartz-tracking/static-1.135",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2968",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20387",
  "ContentUtils": "/ContentUtils/static-1.67666",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2303",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38958",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12825",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12962",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13594",
  "ExportDialog": "/ExportDialog/static-6.10203",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40694",
  "reporting-snowflake": "/reporting-snowflake/static-1.55208",
  "reporting-ui-components": "/reporting-ui-components/static-2.63861",
  "reporting-visualizations": "/reporting-visualizations/static-1.58666",
  "ui-addon-teams": "/ui-addon-teams/static-1.21264",
  "magpie-lib": "/magpie-lib/static-1.5410",
  "magpie-types": "/magpie-types/static-1.4870",
  "simple-logging-lib": "/simple-logging-lib/static-1.2866",
  "navigation-components": "/navigation-components/static-1.17313",
  "ai-studio-lib": "/ai-studio-lib/static-1.11039",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10296",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7806",
  "ui-tool-access": "/ui-tool-access/static-1.9961",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8046",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5567",
  "usage-tracker-public": "/usage-tracker-public/static-1.6961",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3433",
  "persist-promise": "/persist-promise/static-1.3524",
  "reference-resolvers": "/reference-resolvers/static-1.7976",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3760",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.156",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2816",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2225",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4885",
  "purchase-motions-components": "/purchase-motions-components/static-1.5502",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1367",
  "crm-component-utils": "/crm-component-utils/static-1.38516",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5688",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6689",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7910",
  "navigation-messaging": "/navigation-messaging/static-1.6640",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9507",
  "cms-field-types": "/cms-field-types/static-1.4622",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7063",
  "crm-message-bus": "/crm-message-bus/static-1.42405",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21393",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9639",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4544",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3848",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6594",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.789",
  "onboarding-tours": "/onboarding-tours/static-1.16284",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13094",
  "academy-common-lib": "/academy-common-lib/static-1.13054",
  "content-assistance-lib": "/content-assistance-lib/static-1.7471",
  "dashboard-lib": "/dashboard-lib/static-1.80688",
  "file-manager-components": "/file-manager-components/static-1.22939",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17926",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17644",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17636",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19495",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8508",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4581",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10731",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8845",
  "user-context": "/user-context/static-1.4915",
  "growth-payments-core": "/growth-payments-core/static-1.24769",
  "reporting-plugins": "/reporting-plugins/static-1.10005",
  "reporting-reports": "/reporting-reports/static-1.66268",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.541",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28883",
  "react-codemirror": "/react-codemirror/static-1.10443",
  "apps-service-types": "/apps-service-types/static-1.3693",
  "oauth-service-types": "/oauth-service-types/static-1.4061",
  "onboarding-scopes": "/onboarding-scopes/static-1.6279",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4498",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7507",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14607",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8609",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2173",
  "purchase-motions-api": "/purchase-motions-api/static-1.5505",
  "signup-constants": "/signup-constants/static-1.18441",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "card-properties-lib": "/card-properties-lib/static-1.43564",
  "crm-actions": "/crm-actions/static-1.6120",
  "crm-cards-data": "/crm-cards-data/static-1.1240",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42963",
  "customer-data-properties": "/customer-data-properties/static-1.50840",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8836",
  "customer-data-tracking": "/customer-data-tracking/static-1.6698",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3638",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3979",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3532",
  "external-options-client-types": "/external-options-client-types/static-1.3999",
  "react-dnd-compat": "/react-dnd-compat/static-1.4436",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5175",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2888",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1327",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.350",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7344",
  "academy-service-client": "/academy-service-client/static-1.3496",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27981",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8200",
  "video-components-external": "/video-components-external/static-1.10612",
  "video-data-lib": "/video-data-lib/static-1.34270",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8384",
  "payment-link-components": "/payment-link-components/static-1.22978",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9704",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23940",
  "viral-links-lib": "/viral-links-lib/static-1.6851",
  "data-token-picker": "/data-token-picker/static-1.16066",
  "FileManagerLib": "/FileManagerLib/static-1.38579",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5060",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17044",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8319",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.207",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "crm_data": "/crm_data/static-4.91262",
  "crm-links": "/crm-links/static-1.6083",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45457",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15088",
  "crm-fe-perf": "/crm-fe-perf/static-1.22722",
  "calling-global-api": "/calling-global-api/static-1.63726",
  "calling-internal-common": "/calling-internal-common/static-1.31111",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65108",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57402",
  "commerce-products-lib": "/commerce-products-lib/static-1.8903",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.494",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4063",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.449",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48031",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3802",
  "property-value-citations": "/property-value-citations/static-1.1454",
  "pulse": "/pulse/static-1.330",
  "smart-property-lib": "/smart-property-lib/static-1.5970",
  "tiered-pricing": "/tiered-pricing/static-1.852",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10810",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1355",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6399",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11512",
  "content-media-compositions": "/content-media-compositions/static-2.15519",
  "media-bridge-lib": "/media-bridge-lib/static-1.18589",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5742",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4902",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3484",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21331",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3660",
  "audio-components": "/audio-components/static-1.5634",
  "FileManagerCore": "/FileManagerCore/static-1.38438",
  "FileManagerImages": "/FileManagerImages/static-1.36090",
  "video-components": "/video-components/static-1.12615",
  "crm_universal": "/crm_universal/static-1.21684",
  "customer-data-email": "/customer-data-email/static-1.17694",
  "calling-error-reporting": "/calling-error-reporting/static-1.31117",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36542",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38897",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18540",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11248",
  "customer-data-content": "/customer-data-content/static-1.26898",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54081",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20905",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17187",
  "project-storage": "/project-storage/static-1.4549",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71260",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5344",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9592",
  "policy-lib": "/policy-lib/static-1.6603",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10854",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6356",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.288",
  "commerce-permissions": "/commerce-permissions/static-1.575",
  "products-iframe-lib": "/products-iframe-lib/static-1.7357",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9891",
  "directed-graph": "/directed-graph/static-1.753",
  "event-emitter": "/event-emitter/static-1.763",
  "react-tinymce": "/react-tinymce/static-1.54660",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9655",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53786",
  "tinymce-plugins": "/tinymce-plugins/static-1.56900",
  "tinymce-themes": "/tinymce-themes/static-1.55756",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4348",
  "video-embed": "/video-embed/static-1.35104",
  "social-insights-client-types": "/social-insights-client-types/static-1.21398",
  "sequences-lib": "/sequences-lib/static-1.7708",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10163",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17960",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36474",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9833",
  "utility-belt": "/utility-belt/static-1.2356",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22072",
  "products-ui-components": "/products-ui-components/static-1.39422",
  "quotes-client-types": "/quotes-client-types/static-1.37349",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79980",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8927",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6746",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54097",
  "commerce-products-api": "/commerce-products-api/static-1.1979",
  "SafeStorage": "/SafeStorage/static-1.4220",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56155",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101937",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35065",
  "sales-views-client-types": "/sales-views-client-types/static-1.4103",
  "hub-http-contrib": "/hub-http-contrib/static-1.2859",
  "interframe": "/interframe/static-3.4605",
  "tinymce-data": "/tinymce-data/static-1.39871",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5029",
  "layout-dnd-components": "/layout-dnd-components/static-1.12062",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11037",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13964",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8911",
  "outpost": "/outpost/static-1.4020",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7565",
  "customer-data-associations": "/customer-data-associations/static-1.7154",
  "framework-data-table": "/framework-data-table/static-2.11448",
  "customer-data-rte": "/customer-data-rte/static-1.32479",
  "cv-backend-services": "/cv-backend-services/static-1.1505",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5386",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14262",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4928",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7157",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.333",
  "property-description-translator": "/property-description-translator/static-1.3674",
  "FireAlarmUi": "/FireAlarmUi/static-1.4345",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4006",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3472",
  "totals-ui-components": "/totals-ui-components/static-1.23035",
  "ContentData": "/ContentData/static-1.67741",
  "layout-data-lib": "/layout-data-lib/static-1.9362",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1300",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27748",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3653",
  "advanced-menus-core": "/advanced-menus-core/static-1.14837",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11810",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33467",
  "deal-intel-utils": "/deal-intel-utils/static-1.1304",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14836",
  "simple-menus-lib": "/simple-menus-lib/static-1.16353"
}
};
